<a
  class="guided-search-tile-container"
  [class.no-pointer-events]="loading"
  fxFlex="grow"
  (click)="onTileClick(category)"
  (keydown.enter)="onTileClick(category)"
  eventPreventDefault
  tabindex="0"
>
  <zelis-card
    [stroke]="true"
    [elevated]="true"
    class="guided-search-tile text-black"
    fxFlex="grow"
    fxLayout.lt-md="row wrap"
    fxLayout.gt-sm="column"
    [fxLayoutAlign]="
      showAllCategories ? 'center center' : 'space-between stretch'
    "
    ngClass.lt-md="mobile block"
    [class.smartshopper]="smartshopper"
    [emphasis]="smartshopper ? smartshopperEmphasis : undefined"
  >
    <mat-card-content class="block p-4">
      <ng-container *ngIf="!loading; else loadTile">
        <div
          *ngIf="!showAllCategories; else allCategories"
          class="tile-div"
          fxFlex="100"
          fxLayoutAlign="space-between center"
        >
          <div
            class="tile-name pad right-1x"
            #title
            fxFlex="80"
            fxFlexOrder.lt-md="2"
          >
            <h3
              *ngIf="smartshopper; else tileName"
              [innerHTML]="'rts_title' | translate"
              class="dls-subhead-1-bold leading-7"
              [fittext]="true"
              [activateOnResize]="true"
              [modelToWatch]="mediaQuery.isActive('gt-sm')"
              [minFontSize]="16"
              [maxFontSize]="mediaQuery.isActive('gt-sm') ? 24 : 16"
              pendoTrack
              [pendoTrackEventOnShow]="true"
              [pendoTrackEvent]="{
                name: 'SmartShopper Browse Tile Loads',
                data: { ss_browse_tile_loaded: true }
              }"
            ></h3>
            <ng-template #tileName>
              <h3
                [innerHTML]="category?.name | translate"
                class="dls-subhead-1-bold leading-7"
                pendoTrack
                [pendoTrackEventOnShow]="
                  category?.name === 'medication_finder_title'
                "
                [pendoTrackEvent]="{
                  name: 'MedFinder Browse Tile Loaded',
                  data: { medFinder_browse_tile_loaded: true }
                }"
              ></h3>
            </ng-template>
          </div>
          <div
            *ngIf="category?.icon || smartshopper"
            fxLayoutAlign.gt-sm="center start"
            fxFlex.gt-sm="20"
            fxFlexOrder.lt-md="1"
            class="tile-icon"
          >
            <mat-icon
              class="tile-icon"
              [svgIcon]="
                smartshopper
                  ? ('home_smartshopper_tile_icon' | translate)
                  : category?.icon
              "
              [inline]="true"
            ></mat-icon>
          </div>
          <div class="arrow" fxHide.gt-sm fxFlex.lt-md="5" fxFlexOrder="3">
            <mat-icon svgIcon="filled-arrow"></mat-icon>
          </div>
        </div>
        <div
          *ngIf="category?.description || smartshopper"
          class="pad top-1x"
          fxFlex="100"
          fxFlexOrder="3"
          fxHide
          fxShow.gt-sm
        >
          <p class="clamp text-small text-color-dark margin-bottom-none">
            {{
              (smartshopper
                ? 'home_smartshopper_tile_description'
                : category.description
              ) | translate
            }}
          </p>
        </div>
      </ng-container>
    </mat-card-content>
  </zelis-card>
</a>

<ng-template #allCategories>
  <div
    fxFlex="100"
    fxLayoutAlign.gt-sm="center center"
    fxLayoutAlign.lt-md="space-between center"
  >
    <div class="tile-name">
      {{ 'home_browse_by_category_all' | translate }}
    </div>
    <mat-icon
      svgIcon="dls-angle-plain-right-light"
      class="chevron margin left-1x"
      fxHide.lt-md
      [inline]="true"
    >
    </mat-icon>
    <div class="arrow" fxHide.gt-sm fxFlex.lt-md="5">
      <mat-icon svgIcon="filled-arrow"></mat-icon>
    </div>
  </div>
</ng-template>

<ng-template #loadTile>
  <div class="load-tile skeleton-loading">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="24px">
      <div fxFlex="grow">
        <div
          ngClass.lt-md="comment-loading"
          ngClass.gt-sm="title-loading"
        ></div>
      </div>
      <div fxHide.lt-md fxFlex="nogrow">
        <div class="avatar-loading"></div>
      </div>
      <div fxHide.gt-sm fxFlex="nogrow">
        <mat-icon svgIcon="dls-angle-plain-right-light"></mat-icon>
      </div>
    </div>
    <div class="comment-loading margin top-4x" fxHide.lt-md></div>
    <div class="comment-loading margin top-1x" fxHide.lt-md></div>
  </div>
</ng-template>
